import { arrayOrArray } from '../../../utils/util';
import { TApiaSystemMessageObj } from '../../../types';
import { ApiaUtil, TDispatchedNotification } from '@apia/components';

export type TMessage = {
  text: string;
  label?: string;
  title?: string;
  type?: string;
};

export type TNotificationMessage = {
  onClose?: string;
  sysMessages?: {
    message: TMessage | TMessage[];
  };
  sysExceptions?: {
    exception: TMessage | TMessage[];
  };
  exceptions?: {
    exception: TMessage | TMessage[];
  };
};

let lastWindowIndex = 0;
export const getWindowIndex = () => {
  lastWindowIndex += 1;
  return lastWindowIndex;
};

export function clearNotifications() {
  ApiaUtil.instance.notifications.closeAll();
}

/**
 * Devuelve un array de notificaciones a partir de
 * una respuesta de Apia.
 */
export const getNotificationMessageObj = (
  data: TApiaSystemMessageObj,
): TDispatchedNotification[] | null => {
  const notifications: TDispatchedNotification[] = [];
  if (data?.sysMessages?.message) {
    notifications.push(
      ...parseServerNotification(data.sysMessages.message, 'warning'),
    );
  }
  if (data?.sysExceptions) {
    notifications.push(
      ...parseServerNotification(data.sysExceptions.exception, 'danger'),
    );
  }
  if (data?.exceptions?.exception) {
    notifications.push(
      ...parseServerNotification(data.exceptions.exception, 'danger'),
    );
  }
  if (notifications.length > 0) return notifications;
  return null;
};

function parseServerNotificationType(
  type: string,
): TDispatchedNotification['type'] {
  switch (type) {
    case '1':
      return 'success';
    case '2':
      return 'warning';
    case '3':
      return 'danger';
    case '4':
      return 'modal';
    default:
      return 'warning';
  }
}

/**
 * Toma un objeto de notificación de servidor y lo convierte a un
 * objeto de notificación de cliente.
 */
export const parseServerNotification = (
  serverNotification: TMessage | TMessage[],
  type: TDispatchedNotification['type'],
): TDispatchedNotification[] => {
  const messages = arrayOrArray(serverNotification);
  return messages.map((current) => {
    const returnNotification: TDispatchedNotification = {
      message: current.text,
      trace: current.label,
      title: current.title,
      type:
        current.type !== undefined
          ? parseServerNotificationType(current.type)
          : type,
    };
    return returnNotification;
  });
};

/**
 * Toma un objeto de respuesta de servidor que puede eventualmente
 * tener notificaciones y las pasa al sistema de notificaciones si
 * es que hay alguna.
 */
export const dispatchNotifications = (alert: TNotificationMessage) => {
  if (alert) {
    if (alert.sysMessages?.message)
      parseServerNotification(alert.sysMessages?.message, 'warning').forEach(
        notify,
      );
    if (alert.exceptions?.exception)
      parseServerNotification(alert.exceptions?.exception, 'danger').forEach(
        notify,
      );
    if (alert.sysExceptions?.exception)
      parseServerNotification(alert.sysExceptions?.exception, 'danger').forEach(
        notify,
      );
  }
};

/**
 * Lanza una notificación mediante el sistema de notificaciones de la
 * aplicación.
 *
 * @param notification - Objeto de tipo TAlertObj que establece el mensaje y el tipo
 * de la notificación entre varias otras opciones.
 *
 * @see useModalError
 */
export function notify(notification: TDispatchedNotification) {
  ApiaUtil.instance.notifications.notify(notification);
}
